<template>
  <div class="newscenter-content">
    <div class="newscenter-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : key == indexActive}" v-for="(item, key) in AnchorsItems"
          :key="key" @click="goAnchor(key)">
          {{item}}
        </div>
      </div>
    </div>
    <!-- <div class="newscenter-bar-place" v-if="secondNavFixed"> -->
    <div class="newscenter-bar-place">
      <div class="newscenter-select-box">
        <el-select  v-model="yearValue" clearable placeholder="年份" @change="yearChange">
          <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <el-select  v-model="monthValue" clearable placeholder="月份"
          :disabled="!yearValue?true:false" @change="monthChange">
          <el-option v-for="item in monthOptions" size="mini" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <!-- 预加载图片 -->
      <div class="hidden-image-cache">
        <img v-for="(item, index) in currentNews" :src="item.img" :key="index">
      </div>
      <div v-if="news.length > 0" class="newscenter-news-item" v-for="item in currentNews" :key="item.id">
        <!-- <div class="logo-case-one" :style="{backgroundImage: 'url(' + item.img + ')'}"> -->
        <div class="logo-case-one" @click="handleJumpPage(item.url)">
          <img class="news-image" :src="item.img"/>
        </div>
        <div class="info-container">
          <div class="info-title" @click="handleJumpPage(item.url)">{{item.title}}</div>
          <div class="info-content">{{item.content}}</div>
          <div class="info-other">
            <div class="info-date">{{item.date}}</div>
            <div class="info-detail" @click="handleJumpPage(item.url)">
              <div class="info-detail-link">了解详情</div>
              <div class="info-detail-icon"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="news-no-data" v-if="news.length == 0">暂无数据</div>
    </div>
    <div v-if="news.length > 0" class="news-pagination">
      <el-pagination :page-size="pageSize" :current-page="currentPage" layout="prev, pager, next" :total="news.length"
        @current-change="newsPageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import newscenter from './data/newscenter';
import RouteKey from '@/common/RouteKey';
import ScrollManager from '@/components/open/common/ScrollManager';

const SCROLL_TOP = 380;
export default {
  name: 'NewsCenter',
  data() {
    return {
      AnchorsItems: {
        INFOEMATION: '优图资讯',
        ACTIVITY: '优图活动',
        TECHNOLOGY: '技术能力',
        REPORT: '趋势报告'
      },
      news: newscenter.INFOEMATION,
      currentNews: [],
      secondNavFixed: false,
      indexActive: 'INFOEMATION',
      yearOptions: [2025, 2024, 2023, 2022, 2021],
      monthOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      yearValue: null,
      monthValue: null,
      pageSize: 5,
      currentPage: 1
    };
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
    this.currentNews = this.news.slice(0, this.pageSize);
  },
  methods: {
    handleMouseScroll(param) {
      if (param == null) {
        return;
      }
      let scrollTop = param.scrollTop;

      if (scrollTop < SCROLL_TOP) {
        this.secondNavFixed = false;
        return;
      }
      this.secondNavFixed = true;
    },
    handleJumpPage(url, key) {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank');
        return;
      }
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    },
    goAnchor(key) {
      this.indexActive = key;
      this.news = newscenter[key];
      this.currentNews = this.news.slice(0, this.pageSize);
      this.currentPage = 1;
      // document.documentElement.scrollTop = SCROLL_TOP;
      this.yearValue = null;
      this.monthValue = null;
    },
    yearChange(key) {
      if (key) {
        this.news = newscenter[this.indexActive].filter(item => {
          if (this.monthValue) {
            return key === item.year && this.monthValue === item.monthValue;
          }
          return key === item.year;
        });
      } else {
        this.monthValue = null;
        this.news = newscenter[this.indexActive];
      }
      this.currentNews = this.news.slice(0, 5);
      this.currentPage = 1;
    },
    monthChange(key) {
      if (key) {
        this.news = newscenter[this.indexActive].filter(item => {
          return this.yearValue === item.year && key === item.month;
        });
      } else {
        this.yearChange(this.yearValue);
      }
      this.currentPage = 1;
      this.currentNews = this.news.filter((item, index) => index < this.pageSize);
    },
    newsPageChange(pageNum) {
      this.currentNews = this.news.slice(pageNum > 1 ? ((pageNum - 1) * this.pageSize) : 0, pageNum * this.pageSize);
      this.currentPage = pageNum;
    }
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.newscenter-content {
  padding-bottom: 120px;
  .newscenter-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #0080FF;
          border-bottom: 4px solid #0080FF;
        }
        &.active-anchors{
          color: #0080FF;
          border-bottom: 4px solid #0080FF;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .newscenter-bar-place {
    width: 1263px;
    margin: 55px auto 0;
    position: relative;
    background-color: #ffffff;
    min-height: 200px;
    .newscenter-select-box {
      position: absolute;
      right: 30px;
      top: -40px;
      /deep/ .el-select .el-input {
        width: 100px !important;
        .el-input__icon {
          line-height: 34px;
        }
      }
    }
    .hidden-image-cache {
      height: 0px;
      width: 0px;
      overflow: hidden;
    }
    .newscenter-news-item {
      /* height: 180px; */
      padding: 20px 0;
      border-bottom: 1px solid rgba(232,236,241,1);
      display: flex;
      .logo-case-one, .info-container{
        display: inline-block;
      }
      .logo-case-one{
        width: 300px;
        height: 158px;
        background-color: #D8D8D8;
        margin-right: 20px;
        .news-image {
          width: 300px;
          height: 158px;
        }
        &:hover {
          cursor: pointer;
          box-shadow: 8px 8px 20px 0 rgba(0,47,73,0.10);
        }
      }
      .info-container {
        flex: 1;
        font-size: 14px;
        color: #3D485D;
        position: relative;
        .info-title {
          /* width: 560px; */
          /* height: 27px; */
          font-family: 'PingFangSC-Semibold';
          font-size: 18px;
          color: #000000;
          line-height: 27px;
          font-weight: 600;
        }
        .info-content {
          opacity: 0.8;
          line-height: 25px;
          margin-top: 10px;
        }
        .info-other {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          .info-date {
            opacity: 0.6;
          }
          .info-detail {
            height: 20px;
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0.6;
            .info-detail-link {
              height: 20px;
              display: inline-block;
              vertical-align: top;
            }
            .info-detail-icon {
              width: 20px;
              height: 20px;
              display: none;
            }
          }
        }
        &:hover {
          cursor: pointer;
          .info-title {
            color: #0080FF;
          }
          .info-other {
            .info-detail {
              color: #0080FF;
              opacity: 1;
              .info-detail-icon {
                display: inline-block;
                background-image: url("./img/arrow_normal.svg");
              }
            }
          }
        }
      }
    }
    .news-no-data {
      color: black;
      opacity: 0.8;
      font-size: 16px;
      color: #3D485D;
      width: 100px;
      margin: 0 auto;
      text-align: center;
      padding-top: 80px;
    }
  }
  .news-pagination {
    padding-top: 40px;
    display: flex;
    justify-content: center;
    /deep/ .el-pagination {
      button {
        border: 1px solid #DDDDDD !important;
        padding: 6px !important;
        min-width: 40px;
        height: 40px;
      }
      .el-pager {
        .number {
          height: 40px;
          line-height: 40px;
          font-family: 'MicrosoftYaHei';
          font-size: 12px;
          color: #3D485D;
          opacity: 0.6;
          text-align: center;
          font-weight: 400;
          padding: 0 5px;
        }
        .active {
          color: #000000;
          opacity: 1;
        }
        .el-icon {
          height: 40px;
          line-height: 40px;
        }
        .more::before {
          line-height: 40px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/NewsCenterHome.vue